import React, { useEffect, useState } from 'react'
import styles from "./styles.module.css"
import { Button, Skeleton, Stack } from '@chakra-ui/react'
import { BiSolidLockAlt } from 'react-icons/bi'
import { Checkbox, Switch, TimePicker, message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { fileRequest, userRequest } from '../../../requestMethod'
import { PlusOutlined } from '@ant-design/icons';
import crossImg from "../../../assets/icons/crossPhotos.svg"
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);



const initialState = {
    address: "",
    buinessSchedule: [
        { status: true, day: 'Mon', from: '00:00:00', to: '00:00:00', _id: '651e98efc1c4da3123ecfdc8' },
        { status: true, day: 'Mon', from: '00:00:00', to: '00:00:00', _id: '651e98efc1c4da3123ecfdc8' },
        { status: true, day: 'Mon', from: '00:00:00', to: '00:00:00', _id: '651e98efc1c4da3123ecfdc8' },
        { status: true, day: 'Mon', from: '00:00:00', to: '00:00:00', _id: '651e98efc1c4da3123ecfdc8' },
        { status: true, day: 'Mon', from: '00:00:00', to: '00:00:00', _id: '651e98efc1c4da3123ecfdc8' },
        { status: true, day: 'Mon', from: '00:00:00', to: '00:00:00', _id: '651e98efc1c4da3123ecfdc8' },
        { status: true, day: 'Mon', from: '00:00:00', to: '00:00:00', _id: '651e98efc1c4da3123ecfdc8' },
        // ... other schedule items
    ],
}
const EditProfile = () => {
    const [loading, setLoading] = useState(false)
    const [user, setData] = useState(initialState)
    const [isRepeated, setIsRepeated] = useState(false);
    const [schedule, setSchedule] = useState([
        { day: 'Mon', status: false, from: null, to: null },
        { day: 'Tue', status: false, from: null, to: null },
        { day: 'Wed', status: false, from: null, to: null },
        { day: 'Thu', status: false, from: null, to: null },
        { day: 'Fri', status: false, from: null, to: null },
        { day: 'Sat', status: false, from: null, to: null },
        { day: 'Sun', status: false, from: null, to: null }
    ]);

    const handleRepeatChange = (e) => {
        const atLeastOneDayEnabled = schedule.some((day) => day.status);        //new add
        if (atLeastOneDayEnabled || !e.target.checked) {
          setIsRepeated(e.target.checked);

        if (e.target.checked) {
            const selectedDay = schedule.find((day) => day.status);
            // Find Monday's schedule and get its time values
            // const mondaySchedule = schedule.find((day) => day.day === 'Mon');
            // const defaultTimeFrom = mondaySchedule ? dayjs(mondaySchedule.from, 'HH:mm:ss') : null;
            // const defaultTimeTo = mondaySchedule ? dayjs(mondaySchedule.to, 'HH:mm:ss') : null;
            if (selectedDay) {
                const defaultTimeFrom = selectedDay.from ? dayjs(selectedDay.from, 'HH:mm:ss') : null;
                const defaultTimeTo = selectedDay.to ? dayjs(selectedDay.to, 'HH:mm:ss') : null;

            // Set the same time for all days if Monday's time is set
            setSchedule((prevSchedule) =>
                prevSchedule.map((day) => ({
                    ...day,
                    status: true,
                    from: defaultTimeFrom ? defaultTimeFrom?.format('HH:mm:ss') : null,
                    to: defaultTimeTo ? defaultTimeTo?.format('HH:mm:ss') : null
                }))
            );
            }
        } else {
            // Reset schedule if repeat is unchecked
            setSchedule((prevSchedule) =>
            prevSchedule.map((day) => ({ ...day, status: false, from: null, to: null }))
        );
        }

    } else {
        // Show a message or perform any action indicating that at least one day should be enabled
        message.warning('Please select at least one day to repeat the same time.');
    }

    };


    const handleSwitchChange = (index) => (checked) => {
        setSchedule((prevSchedule) =>
            prevSchedule.map((day, i) => (i === index ? { ...day, status: checked } : day))
        );
    };

    const handleTimeChange = (index, isFrom) => (time) => {
        const formattedTime = time ? dayjs(time).format('HH:mm:ss') : null; // Format the time or set it to null
        setSchedule((prevSchedule) =>
            prevSchedule.map((day, i) => {
                if (i === index) {
                    return isFrom ? { ...day, from: formattedTime } : { ...day, to: formattedTime };
                }
                return day;
            })
        );
    };
    const userId = JSON.parse(localStorage.getItem("userId"))

    const navigate = useNavigate()
    const getData = () => {
        setLoading(true)
        userRequest.get(`/partner/business/getBusiness?_id=${userId}`).then((res) => {
            setData(res.data.data)
            if (res.data.data.buinessSchedule.length > 0) {
                setSchedule(res.data.data.buinessSchedule)
            }
            setLoading(false)

        })
    }
    const deleteImage = (index) => {
        const newImages = [...user.photos];
        newImages.splice(index, 1); // Remove the image at the given index
        setData({ ...user, photos: newImages }); // Update the user state
    };
    const upload = async (e) => {
        const formData = new FormData();
        const image = e.target.files[0]; // Get the first selected file from the array

        if (image) {

            formData.append('file', image);

            // Append the selected file to the FormData

            fileRequest.post('/api/util/uploadFile', formData)
                .then((res) => {
                    console.log('res:', res.data.url);
                    setData({ ...user, photos: [...user.photos, res.data.url] });
                    // message.success("File uploaded successfully");
                })
                .catch((err) => {
                    console.log(err);
                    message.error("File upload failed");
                });
        }
    };
    useEffect(() => {
        getData()
    }, [])


    const updateData = () => {
        const { _id, buinessSchedule, ...outputObject } = user
        const newData = { ...outputObject, buinessSchedule: schedule }
        userRequest.put(`/partner/business/updateBusiness`, newData).then((res) => {
            message.success("Successfully updated")

        }).catch((err) => {
            message.error("Something went wrong")

            console.log('err:', err)

        })

    }



    return (
        <div className={styles.MainContainer}>
            <div className={styles.firstDiv}>
                <div className={styles.head}> <p onClick={() => navigate("/Profile")}
                //    onClick={() => setViewMeatings(false)}
                > My Profile{'>'} <b>Edit Profile</b></p>
                    <h1>
                        Edit Profile
                    </h1>
                </div>

                <div className={styles.btn}>
                    <Button variant="outline" onClick={() => navigate("/Profile")}>Cancel</Button>
                    <Button bg="black" color="#fff" onClick={updateData}>  Save Changes</Button>
                </div>
            </div>
            <div className={styles.secondDiv}>
                <div className={styles.details}>
                    <span className={styles.title}>
                        Name* <BiSolidLockAlt />
                    </span>
                    <div className={styles.name}>
                        <p>{user?.name}</p>
                    </div>
                    <p className={styles.title}>
                        Category Type*<BiSolidLockAlt />
                    </p>
                    <div className={styles.name}>
                        <p>{user?.category}</p>

                    </div>
                    <p className={styles.title}>Location <BiSolidLockAlt /></p>
                    <p>{user?.address}</p>


                    <Checkbox onChange={handleRepeatChange}>Repeat same time for everyday</Checkbox>
                    <div className={styles.timePickerDiv}>
                    {schedule.map((day, index) => (
                        <div className={styles.timePicker} key={day.day}>
                            <p>{day.day}</p>
                            <Switch checked={day.status} onChange={handleSwitchChange(index)} />
                            <TimePicker
                                placeholder='From'
                                disabled={!day.status}
                                value={day.from ? dayjs(day.from, 'HH:mm:ss') : null}
                                onChange={handleTimeChange(index, true)}
                            />
                            <TimePicker
                                placeholder='To'
                                disabled={!day.status}
                                value={day.to ? dayjs(day.to, 'HH:mm:ss') : null}
                                onChange={handleTimeChange(index, false)}
                            />
                        </div>
                    ))}
                    </div>



                </div>
                <div>
                    <p className={styles.hold}>Hold and drag photos to reorder</p>
                  <div className={styles.photos}>
                            <div>
                                {
                                    user?.photos?.length > 0 ? <div className={styles.mainPhoto}>
                                        <span> <img src={crossImg} className={styles.mainCross} onClick={() => deleteImage(0)} alt="" /></span>
                                        <img src={user?.photos[0]} alt="" />
                                    </div> : <>
                                        <label htmlFor="main">
                                            <div className={styles.uploadMain} >
                                                <PlusOutlined />
                                            </div>
                                        </label>
                                        <input type="file" id='main' onChange={(e) => upload(e)} style={{ display: "none" }} /></>
                                }
                            </div>
                            <div className={styles.subDiv1}>
                                {
                                    user?.photos?.length > 1 ? <div className={styles.subPhoto}>
                                        <span> <img src={crossImg} className={styles.mainCross} onClick={() => deleteImage(1)} alt="" /></span>


                                        <img src={user?.photos[1]} alt="" /></div> : <>
                                        <label htmlFor="main">
                                            <div className={styles.uploadSub} >
                                                <PlusOutlined />
                                            </div>
                                        </label>
                                        <input type="file" id='main' onChange={(e) => upload(e)} style={{ display: "none" }} /></>
                                }

                                {
                                    user?.photos?.length > 2 ? <div className={styles.subPhoto}>
                                        <span> <img src={crossImg} onClick={() => deleteImage(2)} className={styles.mainCross} alt="" /></span>

                                        <img src={user?.photos[2]} alt="" /></div> : <>
                                        <label htmlFor="main">
                                            <div className={styles.uploadSub} >
                                                <PlusOutlined />
                                            </div>
                                        </label>
                                        <input type="file" id='main' onChange={(e) => upload(e)} style={{ display: "none" }} /></>
                                }
                            </div>
                        </div>
                            <div className={styles.subDiv2}>
                                {
                                    user?.photos?.length > 3 ? <div className={styles.subPhoto}>
                                        <span> <img src={crossImg} onClick={() => deleteImage(3)} className={styles.mainCross} alt="" /></span>

                                        <img src={user?.photos[3]} alt="" /></div> : <>
                                        <label htmlFor="main">
                                            <div className={styles.uploadSub} >
                                                <PlusOutlined />
                                            </div>
                                        </label>
                                        <input type="file" id='main' onChange={(e) => upload(e)} style={{ display: "none" }} /></>
                                }

                                {
                                    user?.photos?.length > 4 ? <div className={styles.subPhoto}>
                                        <span> <img src={crossImg} onClick={() => deleteImage(4)} className={styles.mainCross} alt="" /></span>

                                        <img src={user?.photos[4]} alt="" /></div> : <>
                                        <label htmlFor="main">
                                            <div className={styles.uploadSub} >
                                                <PlusOutlined />
                                            </div>
                                        </label>
                                        <input type="file" id='main' onChange={(e) => upload(e)} style={{ display: "none" }} /></>
                                }
                                {
                                    user?.photos?.length > 5 ? <div className={styles.subPhoto}>
                                        <span> <img src={crossImg} onClick={() => deleteImage(5)} className={styles.mainCross} alt="" /></span>

                                        <img src={user?.photos[5]} alt="" /></div> : <>
                                        <label htmlFor="main">
                                            <div className={styles.uploadSub} >
                                                <PlusOutlined />
                                            </div>
                                        </label>
                                        <input type="file" id='main' onChange={(e) => upload(e)} style={{ display: "none" }} /></>
                                }
                            </div>
                    <p className={styles.note}>Note: pictures should not be bigger than 10mb.</p>
                </div>
            </div>

        </div>
    )
}

export default EditProfile